import { useState, useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { Home, Target, Users, Newspaper, Menu } from 'lucide-react'
import clsx from 'clsx'
import { apiUrl } from '../../config/api'

const allTabs = [
  { slug: 'dashboard', icon: Home, label: 'Home', leaderOnly: false },
  { slug: 'missoes', icon: Target, label: 'Missões', leaderOnly: false },
  { slug: 'contatos', icon: Users, label: 'Contatos', leaderOnly: true },
  { slug: 'blog', icon: Newspaper, label: 'Notícias', leaderOnly: false },
]

interface MobileNavProps {
  onMenuClick?: () => void
}

export default function MobileNav({ onMenuClick }: MobileNavProps) {
  const { slug } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const currentPath = location.pathname.split('/')[2] || 'dashboard'
  const [missionsCount, setMissionsCount] = useState(0)
  const isLeader = localStorage.getItem('is_leader') === 'true'
  const tabs = allTabs.filter(t => !t.leaderOnly || isLeader)

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (!token) return
    fetch(apiUrl('/v1/community/missions?tab=active&per_page=1'), {
      headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
    })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d?.meta?.total) setMissionsCount(d.meta.total) })
      .catch(() => {})
  }, [])

  return (
    <nav className="fixed bottom-0 left-0 right-0 h-14 bg-surface-primary border-t border-border-subtle flex items-center justify-around px-4 lg:hidden z-30">
      {tabs.map((tab) => {
        const isActive = currentPath === tab.slug
        const badge = tab.slug === 'missoes' && missionsCount > 0 ? missionsCount : 0
        return (
          <button
            key={tab.slug}
            onClick={() => navigate(`/${slug}/${tab.slug}`)}
            className={clsx(
              'relative flex flex-col items-center justify-center w-12 h-10 rounded-lg transition-colors',
              isActive
                ? 'text-white'
                : 'text-content-muted active:text-content-normal',
            )}
          >
            <div className="relative">
              <tab.icon
                size={22}
                className={clsx(isActive && 'drop-shadow-[0_0_8px_var(--color-primary)]')}
                style={isActive ? { color: 'var(--color-primary)' } : undefined}
              />
              {badge > 0 && (
                <span className="absolute -top-1.5 -right-2.5 min-w-[16px] h-4 flex items-center justify-center rounded-full bg-primary text-white text-[10px] font-bold px-1">
                  {badge}
                </span>
              )}
            </div>
            <span
              className={clsx(
                'text-[10px] mt-0.5',
                isActive ? 'font-semibold' : 'font-medium',
              )}
              style={isActive ? { color: 'var(--color-primary)' } : undefined}
            >
              {tab.label}
            </span>
          </button>
        )
      })}

      {/* Botão Menu — abre o sidebar com todas as opções */}
      <button
        onClick={onMenuClick}
        className="flex flex-col items-center justify-center w-12 h-10 rounded-lg text-content-muted active:text-content-normal transition-colors"
      >
        <Menu size={22} />
        <span className="text-[10px] mt-0.5 font-medium">Menu</span>
      </button>
    </nav>
  )
}
